
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });


$(".child_links").click(function(){
  $(".child_links").toggleClass("active");
});

$(".child_links").click(function(){
  $("ul.sub_menu").toggle();
});


const slider007 = $(".review_slide");
slider007
.slick({
  dots: true,
  slidesToShow: 3,
  centerMode: true,
  slidesToScroll: 1,
  arrows:false,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  